import React, { useEffect } from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Tree from "./Tree";
import datajson from "../data.json";
import SearchIcon from "@material-ui/icons/Search";
import { IconButton, TextField } from "@material-ui/core";
import InputBase from "@material-ui/core/InputBase";
import { makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(({
  styleForInput :{
    "& .MuiTypography-colorTextSecondary":{
     marginBottom:"auto !important"
    }
  },
  mainDiv :{
    "& svg":{
      opacity : "0.8",
      transform : "scaleX(1.2)"
   }
  }
}));
const DropDownMenu = (props) => {
  const translationStyles1=window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";    
  const classes=useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [filter, setFilter] = React.useState("");
  const [arr, setArr] = React.useState(props.state || []);

  const handleArr = (x) => {
    //  console.log("in handle arr");
    let temp = [...arr];
    let i = temp.indexOf(x);
    if (i === -1) {
      temp.push(x);
    } else {
      temp.splice(i, 1);
    }
    // console.log(temp, "temporary");
    setArr(temp);
  };

  var options = props.options;

  if (props?.command) {
    const isNumber = (element) => element === props.command;
    // console.log(options.findIndex(isNumber), "is the index");
    const i = options?.findIndex(isNumber);
    if (i !== selectedIndex) setSelectedIndex(i);
  }

  // console.log("command props", props.command);
  const handleClickListItem = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (event, index) => {
    //  console.log(index,props.label)
    setSelectedIndex(index);
    setAnchorEl(null);
    props?.handleCommand?.(options?.[index], props.label);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // console.log(props,selectedIndex);

  useEffect(() => {
    if (props?.handleControl) {
      props?.handleControl(arr, props.index);
    }
    // console.log(arr, "arr need to");
  }, [arr]);

  return (
    <div
      style={{
        width: `${props.width}px`,
        maxHeight: "27px",
        border: "1px solid #c4c4c4",
        marginLeft: 'auto',
        marginRight: 'auto',
        borderRadius:"2px"
        // margin: "0px 16px",
      }}
      className={classes.mainDiv}
    >
      <List style={{ padding: 0 }}>
        <ListItem
          style={{ padding: "0px 5px", background:"white" }}
          button
          onClick={handleClickListItem}
        >
          <ListItemText
            className={classes.styleForInput}
            style={{ margin: "3px 0px" }}
            secondary={
              <div
                style={{
                  maxHeight: "28px",
                  whiteSpace: "nowrap",
                  overflowY: "auto",
                  color:"#202020",
                  fontSize:"12px",
                  textAlign:translationStyles1?"right":null
                }}
              >
                {props.isshowtree
                  ? arr.map((item, i) => {
                      return (
                        <span
                          key={i}
                          style={{
                            background: "#F0F0F0 0% 0% no-repeat padding-box",
                            borderRadius: "2px",
                            font: "normal normal normal 12px/20px Open Sans",
                            margin: "0px 5px ",
                            marginBottom: "13px",
                            padding: "0px 5px",
                          }}
                        >
                          <span style={{ marginBottom: "3px" }}>{item}</span>
                          <span onClick={() => handleArr(item)}> X</span>
                        </span>
                      );
                    })
                  : options[selectedIndex]}
              </div>
            }
          ></ListItemText>
          <KeyboardArrowDownIcon />
        </ListItem>
      </List>
      <Menu
        // style={{ height: "350px" }}
        id="lock-menu"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        getContentAnchorEl={null}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {props.isshowtree ? (
          <List style={{ marginBottom: "0px", paddingTop: "0px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "318px",
                maxHeight: "28px",
                border: "1px solid #c4c4c4",
                margin: "8px 12px",
                paddingLeft: "8px",
              }}
            >
              <InputBase
                inputProps={{
                  "aria-label":"Control Value1"
                }}  
                aria-label={"Control Value1"}
                style={{ font: "normal normal 600 12px/17px Open Sans" }}
                placeholder="Search"
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
              />
              <IconButton>
                <SearchIcon />
              </IconButton>
            </div>
            <div style={{ maxHeight: "250px", overflowY: "auto" }}>
              <Tree
                handleArr={handleArr}
                arr={arr}
                key={Math.random() * 10}
                data={props.data}
                samplejson={props.data}
                // length={len}
                isfirst={true}
                filter={filter}
                totalparent={""}
                // style={{ marginBottom: "250px" }}
                ischeckbox={true}
              />
            </div>
          </List>
        ) : (
          <>
            {options?.map((option, index) => (
              <MenuItem
                style={{
                  width: `${props.width}px`,
                  font: "normal normal 600 14px/19px Open Sans",
                  overflowY: "auto",
                  justifyContent:translationStyles1?"flex-end":null
                }}
                key={option}
                selected={index === selectedIndex}
                onClick={(event) => handleMenuItemClick(event, index)}
              >
                {option}
              </MenuItem>
            ))}
          </>
        )}
      </Menu>
    </div>
  );
};

export default DropDownMenu;
